var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Separator, Spinner, Table } from 'telia-front-react';
import { observer } from 'mobx-react';
import CreditLimitsErrorNotice from './CreditLimitsErrorNotice';
import React, { Component } from 'react';
import { injectStores } from '../util/StoresUtil';
let CreditLimits = class CreditLimits extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productLimitsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    async componentDidMount() {
        await Promise.all([this.productLimitsStore.fetchProductLimits()]);
    }
    render() {
        const { translate } = this.translateStore;
        if (this.productLimitsStore.isFetching()) {
            return React.createElement(Spinner, null);
        }
        if (this.productLimitsStore.hasError()) {
            return React.createElement(CreditLimitsErrorNotice, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Table, { responsive: "cols", break: "sm" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, translate('limits.type')),
                        React.createElement("th", null, translate('limits.unused')),
                        React.createElement("th", { className: "text-right" }, translate('limits.total')))),
                React.createElement("tbody", null,
                    React.createElement("tr", { key: 1 },
                        React.createElement("td", null, translate('limits.type-product')),
                        React.createElement("td", null, this.getFreeProductLimitDisplayed()),
                        React.createElement("td", { className: "text-right" }, this.getProductLimitDisplayed())))),
            React.createElement(Separator, { spacing: "small", color: "invisible" }),
            React.createElement("p", null, translate('limits.disclaimer')),
            React.createElement(Separator, { spacing: "small", color: "invisible" })));
    }
    getFreeProductLimitDisplayed() {
        const { translate } = this.translateStore;
        const freeProductLimit = this.productLimitsStore.getFreeProductLimit();
        if (!freeProductLimit) {
            return `${translate('limits.no-limit-to-display')}`;
        }
        return `${freeProductLimit} ${translate('limits.currency-sign')}`;
    }
    getProductLimitDisplayed() {
        const { translate } = this.translateStore;
        const productLimit = this.productLimitsStore.getProductLimit();
        if (!productLimit) {
            return `${translate('limits.no-limit-to-display')}`;
        }
        return `${productLimit} ${translate('limits.currency-sign')}`;
    }
};
CreditLimits = __decorate([
    injectStores,
    observer
], CreditLimits);
export default CreditLimits;
